var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3L17 8.397C16.9999 9.20092 16.806 9.99298 16.4347 10.706C16.0634 11.419 15.5256 12.032 14.867 12.493L14.133 13.007C13.4744 13.468 12.9366 14.081 12.5653 14.794C12.194 15.507 12.0001 16.2991 12 17.103L12 21L12 17.1C11.9999 16.2957 11.8057 15.5034 11.4341 14.7901C11.0624 14.0769 10.5241 13.4638 9.865 13.003L9.135 12.493C8.47572 12.0321 7.93739 11.4188 7.56571 10.7054C7.19402 9.99201 6.99996 9.19944 7 8.395L7 3M17 3L20 6M17 3L14 6M7 3L10 6M7 3L4 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/Split.0057854ccd5571a7f0bcd1c10c56e5fe.svg";
export { ForwardRef as ReactComponent };